import { getWPApplication } from './states';

export const services = {
  getWPApplication,
};
